import { render } from "./AppLogo.vue?vue&type=template&id=4f9e5828"
import script from "./AppLogo.vue?vue&type=script&lang=js"
export * from "./AppLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Widgets/AppLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f9e5828"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f9e5828', __exports__)) {
    api.reload('4f9e5828', __exports__)
  }
  
  module.hot.accept("./AppLogo.vue?vue&type=template&id=4f9e5828", () => {
    api.rerender('4f9e5828', render)
  })

}


export default __exports__